<template>
  <div class="lift-step-five">

    <div class="mb-4">
      <HousseComplexe :form="form" />
    </div>

    <h3>FIXATIONS :</h3>
    <v-simple-table class="mt-6">
      <thead>
        <tr>
          <th class="text-center" />
          <th class="text-center">
            Position
          </th>
          <th class="text-center">
            Sangle taille (mm)
          </th>
          <th class="text-center">
            Sangle matière
          </th>
          <th class="text-center">
            Velcro
          </th>
          <th class="text-center">
            Clip
          </th>
          <th class="text-center">
            Coussin
          </th>
          <th class="text-center">
            Atelier (mm)
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>Epaulière</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.shoulder_pad_position" :items="dropdowns.shoulder_pad_position" item-text="label"
                item-value="value" label outlined clearable hide-details @click:clear="
                  $nextTick(() => (form.shoulder_pad_position = null))
                  " />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model.lazy="form.shoulder_pad_size_trap" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Epaulière Sangle" :class="{ error: errors.has('(Fixation) Epaulière Sangle') }"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.shoulder_pad_strap_matter" :items="dropdowns.shoulder_pad_strap_matter"
              item-text="label" item-value="value" label outlined clearable hide-details @click:clear="
                $nextTick(() => (form.shoulder_pad_strap_matter = null))
                " />
          </td>
          <td>
            <v-select v-model="form.shoulder_pad_velcro" :items="dropdowns.shoulder_pad_velcro" item-text="label"
              item-value="value" label outlined clearable hide-details
              @click:clear="$nextTick(() => (form.shoulder_pad_velcro = null))" />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.shoulder_pad_clip" :items="dropdowns.shoulder_pad_clip" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.shoulder_pad_clip = null))" />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.shoulder_pad_cushion" :items="dropdowns.shoulder_pad_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details @click:clear="
                  $nextTick(() => (form.shoulder_pad_cushion = null))
                  " />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.shoulder_pad_workshop" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Epaulière Atelier" :class="{ error: errors.has('(Fixation) Epaulière Atelier') }"
              type="number" hide-details outlined />
          </td>
        </tr>
        <tr>
          <th>Thorax</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.thorax_position" :items="dropdowns.thorax_position" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.thorax_position = null))" />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.thorax_size_trap" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Thorax Sangle" :class="{ error: errors.has('(Fixation) Thorax Sangle') }"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.thorax_strap_matter" :items="dropdowns.thorax_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details
              @click:clear="$nextTick(() => (form.thorax_strap_matter = null))" />
          </td>
          <td>
            <v-select v-model="form.thorax_velcro" :items="dropdowns.thorax_velcro" item-text="label" item-value="value"
              label outlined clearable hide-details @click:clear="$nextTick(() => (form.thorax_velcro = null))" />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.thorax_clip" :items="dropdowns.thorax_clip" item-text="label" item-value="value"
                label outlined clearable hide-details @click:clear="$nextTick(() => (form.thorax_clip = null))" />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.thorax_cushion" :items="dropdowns.thorax_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.thorax_cushion = null))" />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.thorax_workshop" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Thorax Atelier" :class="{ error: errors.has('(Fixation) Thorax Atelier') }"
              type="number" hide-details outlined />
          </td>
        </tr>
        <tr>
          <th>Plastron</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.chest_position" :items="dropdowns.chest_position" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.chest_position = null))" />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.chest_size_trap" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Plastron Sangle" :class="{ error: errors.has('(Fixation) Plastron Sangle') }"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.chest_strap_matter" :items="dropdowns.chest_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details
              @click:clear="$nextTick(() => (form.chest_strap_matter = null))" />
          </td>
          <td>
            <v-select v-model="form.chest_velcro" :items="dropdowns.chest_velcro" item-text="label" item-value="value"
              label outlined clearable hide-details @click:clear="$nextTick(() => (form.chest_velcro = null))" />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.chest_clip" :items="dropdowns.chest_clip" item-text="label" item-value="value"
                label outlined clearable hide-details @click:clear="$nextTick(() => (form.chest_clip = null))" />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.chest_cushion" :items="dropdowns.chest_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.chest_cushion = null))" />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.chest_workshop" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Plastron Atelier" :class="{ error: errors.has('(Fixation) Plastron Atelier') }"
              type="number" hide-details outlined />
          </td>
        </tr>
        <tr>
          <th>Bassin</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.pelvis_position" :items="dropdowns.pelvis_position" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.pelvis_position = null))" />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.pelvis_size_trap" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Bassin Sangle" :class="{ error: errors.has('(Fixation) Bassin Sangle') }"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.pelvis_strap_matter" :items="dropdowns.pelvis_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details
              @click:clear="$nextTick(() => (form.pelvis_strap_matter = null))" />
          </td>
          <td>
            <v-select v-model="form.pelvis_velcro" :items="dropdowns.pelvis_velcro" item-text="label" item-value="value"
              label outlined clearable hide-details @click:clear="$nextTick(() => (form.pelvis_velcro = null))" />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.pelvis_clip" :items="dropdowns.pelvis_clip" item-text="label" item-value="value"
                label outlined clearable hide-details @click:clear="$nextTick(() => (form.pelvis_clip = null))" />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.pelvis_cushion" :items="dropdowns.pelvis_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.pelvis_cushion = null))" />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.pelvis_workshop" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Bassin Atelier" :class="{ error: errors.has('(Fixation) Bassin Atelier') }"
              type="number" hide-details outlined />
          </td>
        </tr>
        <tr>
          <th>Femorale</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.femoral_position" :items="dropdowns.femoral_position" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.femoral_position = null))" />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.femoral_size_trap" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Femorale Sangle" :class="{ error: errors.has('(Fixation) Femorale Sangle') }"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.femoral_strap_matter" :items="dropdowns.femoral_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details
              @click:clear="$nextTick(() => (form.femoral_strap_matter = null))" />
          </td>
          <td>
            <v-select v-model="form.femoral_velcro" :items="dropdowns.femoral_velcro" item-text="label"
              item-value="value" label outlined clearable hide-details
              @click:clear="$nextTick(() => (form.femoral_velcro = null))" />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.femoral_clip" :items="dropdowns.femoral_clip" item-text="label" item-value="value"
                label outlined clearable hide-details @click:clear="$nextTick(() => (form.femoral_clip = null))" />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.femoral_cushion" :items="dropdowns.femoral_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.femoral_cushion = null))" />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.femoral_workshop" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Femorale Atelier" :class="{ error: errors.has('(Fixation) Femorale Atelier') }"
              type="number" hide-details outlined />
          </td>
        </tr>
        <tr>
          <th>Tibiale</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.tibial_position" :items="dropdowns.tibial_position" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.tibial_position = null))" />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.tibial_size_trap" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Tibiale Sangle" :class="{ error: errors.has('(Fixation) Tibiale Sangle') }"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.tibial_strap_matter" :items="dropdowns.tibial_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details
              @click:clear="$nextTick(() => (form.tibial_strap_matter = null))" />
          </td>
          <td>
            <v-select v-model="form.tibial_velcro" :items="dropdowns.tibial_velcro" item-text="label" item-value="value"
              label outlined clearable hide-details @click:clear="$nextTick(() => (form.tibial_velcro = null))" />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.tibial_clip" :items="dropdowns.tibial_clip" item-text="label" item-value="value"
                label outlined clearable hide-details @click:clear="$nextTick(() => (form.tibial_clip = null))" />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.tibial_cushion" :items="dropdowns.tibial_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.tibial_cushion = null))" />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.tibial_workshop" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Tibiale Atelier" :class="{ error: errors.has('(Fixation) Tibiale Atelier') }"
              type="number" hide-details outlined />
          </td>
        </tr>
        <tr>
          <th>Pied</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.foot_position" :items="dropdowns.foot_position" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.foot_position = null))" />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.foot_size_trap" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Pied Sangle" :class="{ error: errors.has('(Fixation) Pied Sangle') }"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.foot_strap_matter" :items="dropdowns.foot_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details
              @click:clear="$nextTick(() => (form.foot_strap_matter = null))" />
          </td>
          <td>
            <v-select v-model="form.foot_velcro" :items="dropdowns.foot_velcro" item-text="label" item-value="value"
              label outlined clearable hide-details @click:clear="$nextTick(() => (form.foot_velcro = null))" />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.foot_clip" :items="dropdowns.foot_clip" item-text="label" item-value="value" label
                outlined clearable hide-details @click:clear="$nextTick(() => (form.foot_clip = null))" />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.foot_cushion" :items="dropdowns.foot_cushion" item-text="label" item-value="value"
                label outlined clearable hide-details @click:clear="$nextTick(() => (form.foot_cushion = null))" />
            </v-layout>
          </td>

          <td>
            <v-text-field v-model="form.foot_workshop" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Pied Atelier" :class="{ error: errors.has('(Fixation) Pied Atelier') }"
              type="number" hide-details outlined />
          </td>
        </tr>
        <tr>
          <th>Poignet</th>
          <td>
            <v-layout align-center>
              <v-select v-model="form.wrist_position" :items="dropdowns.wrist_position" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.wrist_position = null))" />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.wrist_size_trap" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Poignet Sangle" :class="{ error: errors.has('(Fixation) Poignet Sangle') }"
              type="number" hide-details outlined />
          </td>
          <td>
            <v-select v-model="form.wrist_strap_matter" :items="dropdowns.wrist_strap_matter" item-text="label"
              item-value="value" label outlined clearable hide-details
              @click:clear="$nextTick(() => (form.wrist_strap_matter = null))" />
          </td>
          <td>
            <v-select v-model="form.wrist_velcro" :items="dropdowns.wrist_velcro" item-text="label" item-value="value"
              label outlined clearable hide-details @click:clear="$nextTick(() => (form.wrist_velcro = null))" />
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.wrist_clip" :items="dropdowns.wrist_clip" item-text="label" item-value="value"
                label outlined clearable hide-details @click:clear="$nextTick(() => (form.wrist_clip = null))" />
            </v-layout>
          </td>
          <td>
            <v-layout align-center>
              <v-select v-model="form.wrist_cushion" :items="dropdowns.wrist_cushion" item-text="label"
                item-value="value" label outlined clearable hide-details
                @click:clear="$nextTick(() => (form.wrist_cushion = null))" />
            </v-layout>
          </td>
          <td>
            <v-text-field v-model="form.wrist_workshop" v-validate="'numeric|max:4'"
              data-vv-name="(Fixation) Poignet Atelier" :class="{ error: errors.has('(Fixation) Poignet Atelier') }"
              type="number" hide-details outlined />
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HousseComplexe from "../../modules/HousseComplexe.vue";

export default {
  name: "LiftStepFive",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    },
    dropdowns: {
      type: Object,
      required: true
    }
  },
  components: {
    HousseComplexe
  },
  computed: {
    ...mapGetters({
      dropdowns: "dropdowns/getLiftOptions"
    })
  },
  created() {
    this.$validator = this.parentValidator;
  }
};
</script>

<style></style>
